import { Injectable } from '@angular/core';
import { FileType, StackingPlanExportTypes } from '../export.model';
import { StackingPlanService } from '../../../../stacking-plan.service';
import { User, UserRole, hasOneOfTheRoles } from '@miq/user';

@Injectable({ providedIn: 'root' })
export class PVExportConfigGetter {
  constructor(private stackingPlanService: StackingPlanService) {}

  #pdfMenuOption = {
    id: 'e2e_pv_export_pdf',
    label: 'pv.export.menuOptions.exportToPDF',
    exportType: StackingPlanExportTypes.PVPDF,
    fileType: FileType.PDF,
  };

  #excelMenuOption = {
    id: 'e2e_pv_export_excel',
    label: 'pv.export.menuOptions.exportToExcel',
    exportType: StackingPlanExportTypes.PVExcel,
    fileType: FileType.Excel,
  };

  #hasPDFExportPermissions(user: User) {
    return hasOneOfTheRoles(user, [UserRole.USResearcher, UserRole.DandT, UserRole.DIGUser, UserRole.USBroker]);
  }

  #hasExcelExportPermissions(user: User) {
    return hasOneOfTheRoles(user, [UserRole.USResearcher, UserRole.DandT, UserRole.DIGUser]);
  }

  getExportOptions() {
    const user = this.stackingPlanService.resolveUser();
    const availableOptions = [];
    if (this.#hasPDFExportPermissions(user)) {
      availableOptions.push(this.#pdfMenuOption);
    }

    if (this.#hasExcelExportPermissions(user)) {
      availableOptions.push(this.#excelMenuOption);
    }
    return availableOptions;
  }
}
